import { SagaIterator } from 'redux-saga'
import { takeEvery, call } from 'redux-saga/effects'
import { getConfiguration } from '../configuration/index'

import {
	validateCode,
	redeemCode,
	LoadCouponCodeResultSuccess,
	ValidateCodeResultSuccess,
	ValidateCodeResultFailure,
} from '../api/actions'
import { isHttpClientError } from '../api/errors'
import { expireAtFromHours } from '../api/functions'

function* handleValidateCodeDone(action: ValidateCodeResultSuccess): SagaIterator {
	const { couponCode, linkedId, linkedType, onComplete } = action.payload.params
	const { status } = action.payload.result

	if (status === 'invalid' || status === 'expired') {
		try {
			const projectId = getConfiguration().getDefaultAppInfo().projectId
			yield call(getConfiguration().removeCouponCodeFromDisk, projectId, {
				code: couponCode,
				linkedId,
				linkedType,
			})
		} catch (error) {
			// Error deleting old data
		}
		onComplete?.(false)
	} else {
		onComplete?.(true)
	}
}

function* handleValidateCodeFailed(action: ValidateCodeResultFailure): SagaIterator {
	const { couponCode, linkedId, linkedType, onComplete } = action.payload.params

	// Only delete the persisted code on a definitive 4xx rejection (e.g. revoked). A transport
	// failure or 5xx (offline / DNS / backend outage) must not permanently destroy a working
	// unlock — mirrors the optimistic-offline handling in the bundles/collectionownership reducers.
	if (isHttpClientError(action.payload.error)) {
		try {
			const projectId = getConfiguration().getDefaultAppInfo().projectId
			yield call(getConfiguration().removeCouponCodeFromDisk, projectId, {
				code: couponCode,
				linkedId,
				linkedType,
			})
		} catch (error) {
			// Error deleting old data
		}
	}
	onComplete?.(false)
}

function* handleRedeemCodeDone(action: LoadCouponCodeResultSuccess): SagaIterator {
	const { couponCode, linkedId, linkedType } = action.payload.params
	const { status, expire_after, account_id } = action.payload.result

	if (status === 'valid') {
		try {
			const projectId = getConfiguration().getDefaultAppInfo().projectId
			yield call(getConfiguration().saveCouponCodeToDisk, String(projectId), {
				code: couponCode,
				linkedId,
				linkedType,
				expireAt: expireAtFromHours(expire_after),
				addedAt: Date.now(),
				accountId: account_id,
			})
		} catch (error) {
			// Error saving data
		}
	}
}

export default function* (): SagaIterator {
	yield takeEvery(validateCode.done, handleValidateCodeDone)
	yield takeEvery(validateCode.failed, handleValidateCodeFailed)
	yield takeEvery(redeemCode.done, handleRedeemCodeDone)
}
